export enum RoutesWellmaxx {
  WELLMAXX = '/wellmaxx',
  WELLMAXX__AGB = '/wellmaxx/agb',
  WELLMAXX__CLUBFAQS = '/wellmaxx/club-faqs',
  WELLMAXX__CLUBMITGLIEDWERDEN = '/wellmaxx/clubmitglied-werden',
  WELLMAXX__CLUBVERTRAGKUENDIGEN = '/wellmaxx/clubvertrag-kuendigen',
  WELLMAXX__CLUBVERTRAGWIDERRUFEN = '/wellmaxx/clubvertrag-widerrufen',
  WELLMAXX__COOKIEEINSTELLUNGEN = '/wellmaxx/cookie-einstellungen',
  WELLMAXX__COUPONS = '/wellmaxx/coupons',
  WELLMAXX__DATENSCHUTZ = '/wellmaxx/datenschutz',
  WELLMAXX__GEWICHTSREDUKTION = '/wellmaxx/gewichtsreduktion',
  WELLMAXX__GEWICHTSREDUKTION__ABNEHMENMITVITAMIND = '/wellmaxx/gewichtsreduktion/abnehmen-mit-vitamin-d',
  WELLMAXX__GEWICHTSREDUKTION__ABNEHMENOHNEDIAET = '/wellmaxx/gewichtsreduktion/abnehmen-ohne-diaet',
  WELLMAXX__GEWICHTSREDUKTION__FETTVERBRENNUNGOHNESPORT = '/wellmaxx/gewichtsreduktion/fettverbrennung-ohne-sport',
  WELLMAXX__GEWICHTSREDUKTION__PROBLEMZONENBEKAEMPFEN = '/wellmaxx/gewichtsreduktion/problemzonen-bekaempfen',
  WELLMAXX__GEWICHTSREDUKTION__WELLMAXXBODYSLIMV2 = '/wellmaxx/gewichtsreduktion/wellmaxx-bodyslim-v2',
  WELLMAXX__GEWICHTSREDUKTION__WELLMAXXBODYSLIMV2KONZEPT = '/wellmaxx/gewichtsreduktion/wellmaxx-bodyslim-v2-konzept',
  WELLMAXX__HAENDLERANFRAGEN = '/wellmaxx/haendleranfragen',
  WELLMAXX__IMPRESSUM = '/wellmaxx/impressum',
  WELLMAXX__JOBS = '/wellmaxx/jobs',
  WELLMAXX__KOERPERSTRAFFUNG = '/wellmaxx/koerperstraffung',
  WELLMAXX__KOERPERSTRAFFUNG__LYMPHDRAINAGE = '/wellmaxx/koerperstraffung/lymphdrainage',
  WELLMAXX__KOERPERSTRAFFUNG__MASSAGENGEGENCELLULITE = '/wellmaxx/koerperstraffung/massagen-gegen-cellulite',
  WELLMAXX__KOERPERSTRAFFUNG__OBERSCHENKELUNDPOWIRKUNGSVOLLSTRAFFEN = '/wellmaxx/koerperstraffung/oberschenkel-und-po-wirkungsvoll-straffen',
  WELLMAXX__KOERPERSTRAFFUNG__SCHNELLEHILFEBEIMUSKELKATERUNDSCHWERENBEINEN = '/wellmaxx/koerperstraffung/schnelle-hilfe-bei-muskelkater-und-schweren-beinen',
  WELLMAXX__KOERPERSTRAFFUNG__WELLMAXXBODYSTYLE = '/wellmaxx/koerperstraffung/wellmaxx-bodystyle',
  WELLMAXX__KOERPERSTRAFFUNG__WELLMAXXBODYSTYLEKONZEPT2 = '/wellmaxx/koerperstraffung/wellmaxx-bodystyle-konzept-2',
  WELLMAXX__KONTAKT = '/wellmaxx/kontakt',
  WELLMAXX__KONZEPT = '/wellmaxx/konzept',
  WELLMAXX__KONZEPT__CLUB = '/wellmaxx/konzept/club',
  WELLMAXX__KONZEPT__ERFAHRUNGSBERICHTE = '/wellmaxx/konzept/erfahrungsberichte',
  WELLMAXX__KONZEPT__ERNAEHRUNGSTIPPS = '/wellmaxx/konzept/ernaehrungstipps',
  WELLMAXX__KONZEPT__KOMBICLUB = '/wellmaxx/konzept/kombi-club',
  WELLMAXX__KONZEPT__STUDIOFINDER = '/wellmaxx/konzept/studiofinder',
  WELLMAXX__KONZEPT__WELLMAXXBODYFORMING = '/wellmaxx/konzept/wellmaxx-bodyforming',
  WELLMAXX__KONZEPT__WELLMAXXBODYFORMINGKONZEPT = '/wellmaxx/konzept/wellmaxx-bodyforming-konzept',
  WELLMAXX__KOOPERATIONENINFLUENCER = '/wellmaxx/kooperationen-influencer',
  WELLMAXX__KOSMETIK = '/wellmaxx/kosmetik',
  WELLMAXX__NEWSLETTER = '/wellmaxx/newsletter',
  WELLMAXX__PRESSE = '/wellmaxx/presse',
  WELLMAXX__TESTERINANDREA = '/wellmaxx/testerin-andrea',
  WELLMAXX__VIBRATIONSTRAINING = '/wellmaxx/vibrationstraining',
  WELLMAXX__WIDERRUFSBELEHRUNG = '/wellmaxx/widerrufsbelehrung',
}
